import styled from 'styled-components';

const LiBase = styled.li`
  display: inline-block;
  position: relative;

  &:not(:last-child) {
    margin-right: 18px;
  }

  &:not(:last-child)::after {
    margin-right: 12px;
    position: absolute;
    top: 10px;
    right: -22px;
    display: inline-block;
    content: '';
    height: 3px;
    width: 3px;
    border-radius: 50px;
  }
`;

const Li = styled(LiBase)`
  &:not(:last-child)::after {
    background: ${({ theme }) =>
      theme.pointCard.colors.backgroundSortInfoDivider};
  }
`;

export const S = {
  Container: styled.div`
    width: 100%;
    height: 100%;
    padding: ${({ theme }) =>
      theme.plannedRoute.sizes.padding};
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: space-between; // <- this spreads items
    border-bottom: 1px solid
      ${({ theme }) => theme.pointCard.colors.backgroundContainer};
    cursor: pointer;
  `,
  RouteInfo: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: calc(100% - 60px);
    flex: 1;
  `,
  Sidebar: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  `,
  Title: styled.div`
    font-size: ${({ theme }) =>
      theme.plannedRoute.sizes.titleFont};
    font-weight: bold;
    white-space: normal;
    word-break: break-word;

    display: -webkit-box;
    -webkit-line-clamp: ${({ theme }) =>
      theme.plannedRoute.sizes.titleMaxLines};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  Description: styled.div`
    font-size: ${({ theme }) =>
      theme.plannedRoute.sizes.descriptionFont};
    white-space: normal;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: ${({ theme }) =>
      theme.plannedRoute.sizes.descriptionMaxLines};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  ShortInfo: styled.ul`
    font-size: 14px;
    margin: 0;
    padding: 0;
    color: #777; // light gray text
  `,
  LiBase,
  Li,
  Location: styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
};
